export const CUSTOM_DISCLOSURE_ENDPOINTS = {
  LIST: "/custom-disclosures",
  GET: (id) => `/custom-disclosures/${id}`,
  CREATE: "/custom-disclosures",
  UPDATE: (id) => `/custom-disclosures/${id}`,
  DELETE: (id) => `/custom-disclosures/${id}`,
  ARCHIVE: (id) => `/custom-disclosures/${id}/archive`,
  RESTORE: (id) => `/custom-disclosures/${id}/restore`,
  CLONE: (id) => `/custom-disclosures/${id}/clone`,
  SET_TEMPLATE: (id) => `/custom-disclosures/${id}/template`,
  TEMPLATES: "/custom-disclosures/templates/list",
  BULK_ARCHIVE: "/custom-disclosures/bulk/archive",
  BULK_DELETE: "/custom-disclosures/bulk/delete",
  USAGE: (id) => `/custom-disclosures/${id}/usage`,
  ANALYTICS: "/custom-disclosures/analytics/summary",
};
